// 手机号码规则
export function phoneRule(country) {
  if (country == '中国大陆') {
    return {
      value: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
      message: '请输入正确的联系电话',
    };
  }

  return null;
}

// 检查国际区号是否匹配
// 传入参数: phoneCode, countryCode, phoneCodeList
export function checkPhoneCode(phoneCode, countryCode, phoneCodeList, onlyCheck) {
  let value = typeof phoneCode == 'string' ? phoneCode.replace(/\s*/g, '') : phoneCode;

  let parsedNum = parseInt(value);
  if (!Number.isNaN(parsedNum)) {
    let i = phoneCodeList.findIndex((el) => el.phoneCode == parsedNum && el.countryCode == countryCode); //
    if (onlyCheck) {
      i = phoneCodeList.findIndex((el) => el.phoneCode == parsedNum);
    }
    // 找到匹配时
    if (i !== -1) {
      return {
        phoneCode: phoneCodeList[i].phoneCode,
        countryCode: phoneCodeList[i].countryCode,
        index: i,
      };
    }
  }

  return { index: -1 };
}

export const EMAIL_PATTERN =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
